import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

export function formatRelativeTime(value: unknown, now: dayjs.Dayjs = dayjs()): string {
  if (value === null || value === undefined || value === "") return "—";

  const date = dayjs(value as string | number | Date);
  if (!date.isValid()) return String(value);

  return now.to(date);
}
